import { Link } from "react-router-dom";

export default function ForumAgentSection() {
  return (
    <section className="py-20 px-5 sm:px-8 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left — visual */}
          <div className="relative order-2 lg:order-1">
            <div className="absolute inset-0 bg-gradient-to-br from-red-500/10 to-orange-500/10 rounded-3xl blur-3xl scale-110"></div>
            <div className="relative bg-gradient-to-br from-slate-900 via-red-950 to-slate-900 rounded-2xl border border-red-500/20 shadow-2xl p-6 md:p-8">
              {/* Simulated forum reply cards */}
              <div className="space-y-4">
                {[
                  {
                    platform: "reddit",
                    icon: "ri-reddit-fill",
                    iconBg: "bg-orange-500",
                    subreddit: "r/entrepreneur",
                    question: "How do I grow my online community from scratch?",
                    reply: "Great question! Start by posting consistently on social media and joining niche forums. I actually found a community on Skool that helped me 10x my reach — check it out at...",
                  },
                  {
                    platform: "quora",
                    icon: "ri-questionnaire-fill",
                    iconBg: "bg-red-600",
                    subreddit: "Quora · Digital Marketing",
                    question: "What's the best way to get members for a paid community?",
                    reply: "The fastest method is combining SEO content with targeted social outreach. Tools like ClickSendAI automate the outreach side — posting relevant content to 30+ platforms...",
                  },
                ].map((item) => (
                  <div key={item.subreddit} className="bg-white/5 border border-white/10 rounded-xl p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <div className={`w-6 h-6 flex items-center justify-center rounded-full ${item.iconBg}`}>
                        <i className={`${item.icon} text-white text-xs`}></i>
                      </div>
                      <span className="text-xs text-slate-400 font-medium">{item.subreddit}</span>
                      <span className="ml-auto text-xs text-emerald-400 font-semibold flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 inline-block animate-pulse"></span>
                        AI replied
                      </span>
                    </div>
                    <p className="text-xs text-slate-300 font-semibold mb-2">"{item.question}"</p>
                    <p className="text-xs text-slate-400 leading-relaxed italic">"{item.reply}"</p>
                  </div>
                ))}
                <div className="flex items-center justify-between px-2">
                  <span className="text-xs text-slate-500">Running 24/7 automatically</span>
                  <span className="text-xs text-emerald-400 font-semibold">47 replies sent today</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right — description */}
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/10 border border-red-400/30 text-red-600 text-xs font-semibold mb-6">
              <i className="ri-robot-2-fill"></i>
              Add-on · Included in Elite
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5 leading-tight">
              Reddit &amp; Quora
              <span className="block bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
                AI Lead Generation Agent
              </span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              An AI agent that monitors Reddit and Quora 24/7 for posts about your niche, automatically replies with genuinely helpful answers, and organically links readers back to your group — driving free traffic while you sleep.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                { icon: "ri-search-eye-line", color: "bg-red-100 text-red-500", text: "Scans subreddits & Quora topics related to your niche" },
                { icon: "ri-chat-ai-fill", color: "bg-orange-100 text-orange-500", text: "AI writes contextual, helpful replies — not spam" },
                { icon: "ri-links-fill", color: "bg-amber-100 text-amber-600", text: "Drops your group link naturally into every reply" },
                { icon: "ri-24-hours-fill", color: "bg-emerald-100 text-emerald-600", text: "Runs 24/7 automatically — zero manual effort" },
                { icon: "ri-bar-chart-2-fill", color: "bg-violet-100 text-violet-600", text: "Track replies, traffic, and new member conversions" },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3 text-sm text-gray-600">
                  <div className={`w-7 h-7 flex items-center justify-center rounded-lg flex-shrink-0 mt-0.5 ${item.color}`}>
                    <i className={`${item.icon} text-sm`}></i>
                  </div>
                  {item.text}
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/product/forum-agent"
                className="px-6 py-3 rounded-xl bg-gradient-to-r from-red-500 to-orange-500 text-white font-semibold text-sm hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
              >
                Learn More
              </Link>
              <Link
                to="/get-started"
                className="px-6 py-3 rounded-xl border border-gray-200 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
